import * as React from "react";
import * as classnames from "classnames";
import * as _ from "lodash";
import {ITagsOffer} from "../actions/fetch_tags_offer_list";
import {SortDirection} from "../../../../shared/ts/decorators/sort";
import CenterBox from "../../shared/layout/CenterBox";
import Loader from "../../shared/loader/Loader";
import TagsOfferListItem from "./TagsOfferListItem";
import TableHeader, {TableHeaderProps} from "../../shared/table/TableHeader";
import Table from "../../../../shared/ts/components/table/Table";
import TableRow from "../../shared/table/TableRow";


interface IProps {
    offers: ITagsOffer[];
    onSort: (column: string) => void;
    sortName: string;
    sortDirection: SortDirection | null;
    loading?: boolean;
}

export const TagsOfferList = (props: IProps) => {
    const renderLoader = () => {
        return (
            <CenterBox className="vhc pt-lg">
                <Loader size="lg"/>
            </CenterBox>
        );
    };

    const tbodyClassName = classnames({"o40": !!props.loading});
    const loader = props.loading ? renderLoader() : null;

    const offerListItem = _.map(props.offers, (offer: ITagsOffer, idx: number) => {
        return <TagsOfferListItem key={idx} offer={offer} />;
    });

    // Sortable table columns
    const sortableHeaderProps = (sortName: string): TableHeaderProps => ({
        sortable: true,
        onHeaderClick: props.onSort,
        sortDirection: sortName === props.sortName ? props.sortDirection : null,
        sortName
    });

    return (
        <div className="psr">
            <Table hover className="table mb-0">
                <thead>
                <TableRow>
                    <TableHeader {...sortableHeaderProps("name")}>Nazwa inwestycji</TableHeader>

                    <TableHeader {...sortableHeaderProps("vendor__name")}>Deweloper</TableHeader>

                    <TableHeader>Lokalizacja</TableHeader>
                </TableRow>
                </thead>

                <tbody className={tbodyClassName}>
                    {offerListItem}
                </tbody>
            </Table>

            {loader}
        </div>
    );
};


